import { Popover, Statistic } from 'antd'
import { useParams } from 'react-router-dom'
import { useStatsSingleProject } from '../../../hooks/useStatsSingleProject'
import { EventType } from '../../../Types'

export function ScreenFailRate() {
  const { projectId } = useParams() as { projectId: string }
  const { barChartData, countsPerState, numDbResponders } = useStatsSingleProject(projectId)

  const noShows = barChartData.failed[3]
  const showedUp = barChartData.success[3]
  const noShowRate = Math.round((noShows / (noShows + showedUp)) * 100)

  const noShowPopoverContent = (
    <div>
      <p>No-shows: {noShows}</p>
      <p>Showed-up: {showedUp}</p>
      <p>&nbsp;</p>
      <p>No show rate = {noShowRate}</p>
      <p className="text-muted">
        ({noShows} / ({noShows} + {showedUp}) * 100)
      </p>
    </div>
  )

  const screenFails = barChartData.failed[4]
  const randoFails = barChartData.failed[5]
  const allScreenFails = screenFails + randoFails

  const screened = countsPerState[EventType.SignedConsent]
  const randomized = countsPerState[EventType.SubjectRandomised]

  const screenFailUpperBound = Math.round((allScreenFails / (allScreenFails + randomized)) * 100)
  const screenFailLowerBound = Math.round((allScreenFails / screened) * 100)

  const screenFailPopoverContent = (
    <div>
      <p className="text-muted">Problem: what about run-ins?</p>
      <p className="text-muted">Solution: we use intervals</p>
      <p>&nbsp;</p>
      <p>screenFails: {screenFails}</p>
      <p>randoFails: {randoFails}</p>
      <p>= allScreenFails: {allScreenFails}</p>
      <p>&nbsp;</p>
      <p>screened: {screened}</p>
      <p>randomized: {randomized}</p>
      <p>
        &nbsp;
        <br />
        &nbsp;
      </p>
      <p>screenFailLower</p>
      <p>
        = (allScreenFails / <b>screened</b>) * 100
      </p>
      <p>
        = ({allScreenFails} / {screened}) * 100
      </p>
      <p> = {screenFailLowerBound} %</p>
      <p>&nbsp;</p>
      <p>screenFailUpper</p>
      <p>
        = (allScreenFails / <b>(allScreenFails + randomized)</b>) * 100
      </p>
      <p>
        = ({allScreenFails} / ({allScreenFails} + {randomized})) * 100
      </p>
      <p> = {screenFailUpperBound} %</p>
    </div>
  )

  return (
    <div className="row">
      <div className="col-4">
        <Popover content={noShowPopoverContent}>
          <Statistic title="No Show" value={noShowRate} suffix={<span className="text-muted p-small ">%</span>} />
        </Popover>
      </div>
      <div className="col-4">
        <Popover content={screenFailPopoverContent}>
          <Statistic
            title="Screen Fail"
            value={screenFailLowerBound}
            suffix={
              <span>
                - {screenFailUpperBound} {<span className="text-muted p-small ">%</span>}
              </span>
            }
          />
        </Popover>
      </div>
      <div className="col-4">
        <Statistic title="Db Responders" value={numDbResponders} />
      </div>
    </div>
  )
}
